import './App.css';
import { useState } from 'react';
import NavBar from './components/NavBar';
import Body from './components/Body';
import SimpleSlider from './components/HeroCarousel';
import HeroSection from './components/HeroSection';
import OurBestSellers from './components/OurBestSellers';
import Ingridients from './components/Ingridients';
import JournalSection from './components/JournalSection';
import BsText from './components/BsText';
import { Route, Routes } from 'react-router-dom';
import { BrowserRouter } from 'react-router-dom';
import SinglePage from "./components/SinglePage";
import JournalPage from "./components/JournalPage";
import SPFooter from './components/SPFooter';
import ContactUs from './components/Contatusnew';
import AboutUs from './components/Aboutus';
import BotChat from './components/BotChat';
import ProductList from './components/ProductList';
import Loginpage from './components/Loginpage';
import ChangePasswordComponent from './components/ChangePasswordComponent';
import TestimonialSection from './components/TestimonialSection';
import Changepass from './components/Changepass';
import Newtest from './components/Newtest';
import PopupComponent from './components/PopupComponent';
import NavAvatar from './components/NavAvatar';
import HomePage1 from './components/HomePage1';
import WelcomePage from './components/WelcomePage';
import ProductListt from './components/ProductListt';
import Services from './components/Services';
import Testimonials from './components/Testimonials';
import TechnologicalSolutions from './components/TechnologicalSolutions';
import Home from './components/Home';
import Journals from './components/Journals';
import Navbarr from './components/Navbarr';
import ToastComponent from './components/ToastComponent';
import RegisterForm from './components/RegisterForm';
import LoadingLogo from './components/LoadingLogo';
import Someofourcustomers from'./components/Someofourcustomers';
import CardComponent from './components/CardComponent';
import FormComponent from './components/FormComponent';
import SignInSide from './components/SignInSide';
import SignUp from './components/SignUp';
import Newsn from './components/Newsn';
import Checkout from './components/Checkout';
import FormDownload from './components/FormDownload';
import Navbard from './components/Navbard';
import Drogalogin from './components/Drogalogin';
import AboutUsPage from './components/AboutUsPage';
import Newproducttoaboutus from './components/Newproducttoaboutus';
import EmployeeSendMessage from  './components/EmployeeSendMessage';
import ManagerMessageList from './components/ManagerMessageList';
import Notification from './components/Notification';
import Botchatdroga from './components/Botchatdroga';
import Chatbot from './components/Chatbot';
import OurMission from './components/OurMission';
import Atest from './components/Atest'



function App() {

  return (
    <div className="App">
      <BrowserRouter>

        <Routes >
          <Route path='/' exact element={<>   <Navbarr /> <Home />  <WelcomePage /> <Ingridients />  <ProductList /> <Services /> <TestimonialSection /> <ContactUs /> <Someofourcustomers /> <SPFooter /> <BotChat /> </>} />

          <Route path='/journal/april' element={<> <Navbarr /> <JournalPage /> </>} />
          <Route path='/contactus' element={<> <Navbarr />  <ContactUs /> </>} />
          <Route path='/Aboutus' element={<> <Navbarr />  <AboutUs /> </>} />
          <Route path='/botchat' element={<> <Navbarr />  <BotChat /> </>} />
          <Route path='/productlist' element={<> <Navbarr />  <ProductList /> </>} />
          <Route path='/login' element={<> <Loginpage /> </>} />
          <Route path='/changepassword' element={<> <ChangePasswordComponent /> </>} />
          <Route path='/TestimonialSection' element={<> <Navbarr />  <TestimonialSection /> </>} />
          <Route path='/Changepass' element={<> <Changepass />  <test /> </>} />
          <Route path='/NavAvatar' element={<> <NavAvatar /> </>} />
          <Route path='/WelcomePage' element={<> <WelcomePage /> </>} />
          <Route path='/ProductListt' element={<> <Navbarr /> <ProductListt /> </>} />
          <Route path='/Services' element={<> <Navbarr /> <Services />   </>} />
          <Route path='/product/:id' element={<> <Navbarr /> <SinglePage /> </>} />
          <Route path='/Testimonials' element={<> <Testimonials /> </>} />
          <Route path='/TechnologicalSolutions' element={<> <TechnologicalSolutions /> </>} />
          <Route path='/Home' element={<> <Home /> </>} />
          <Route path='/ToastComponent' element={<> <ToastComponent /> </>} />
          <Route path='/RegisterForm' element={<> <RegisterForm /> </>} />
          <Route path='/LoadingLogo' element={<> <LoadingLogo /> </>} />
          <Route path='/CardComponent' element={<> <CardComponent /> </>} />
          <Route path='/FormComponent' element={<> <FormComponent /> </>} />
          <Route path='/Checkout' element={<> <Checkout /> </>} />
          <Route path='/FormDownload' element={<> <Navbard /> <FormDownload /> </>} />
          <Route path='/Navbard' element={<> <Notification /><Navbard /> </>} />
          {/* // <Route path='/Drogalogin' element={<> <Drogalogin /> </>} /> */}
          <Route path='/AboutUsPage' element={<> <AboutUsPage /> </>} />
          <Route path='/Newproducttoaboutus' element={<> <Newproducttoaboutus /> </>} />

          <Route path='/Chatbot' element={<> <Chatbot /> </>} />
          <Route path='/OurMission' element={<> <OurMission /> </>} />
          <Route path='/Atest' element={<> <Atest /> </>} />
        </Routes>

      </BrowserRouter>




    </div>
  );
}

export default App;




